import styled from "styled-components";
import { H500, H800, T300 } from "../Styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

type BenefitsSectionProps = {
  hotelLoyalty: any;
  loyaltyBenefits: any;
}

type IconContainerProps = {
  color?: string;
}

type BenefitCardProps = {
  icon_class: string;
  title: string;
  description: string;
  primary_color: string;
}

const BenefitsSectionWrapper = styled.div`
  padding: 104px 120px;

  ${({ theme }) => theme.tablet`
    padding: 64px 24px;
  `}
`;

const BenefitsSectionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 80px;
  align-items: center;
`;

const BenefitsSectionHeader = styled(H800)`
  font-family: Sentient;
  margin-bottom: 8px;
  max-width: 720px;
  align-self: center;
`;

const TopContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  text-align: center;
`;

const BottomContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 64px;

  ${({ theme }) => theme.tablet`
    grid-template-columns: 1fr;
  `}
`;

const BenefitCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  text-align: center;
`;

const BenefitCardHeader = styled(H500)`
  font-family: Sentient; 
`;

const IconContainer = styled.div<IconContainerProps>`
  color: #785827;
  margin-bottom: 8px;

  svg {
    height: 40px;
    width: 40px;
    color: ${({ color }) => color ? `#${color}` : 'inherit'};
  }
`;

const BenefitCard = ({
  icon_class,
  title,
  description,
  primary_color
}: BenefitCardProps) => {
  const [icon, setIcon] = useState(icon_class.replace("fa-", "") as IconProp);

  useEffect(() => {
    let tempIcon = icon_class.replace("fa-", "");
    if (tempIcon === "money") {
      tempIcon = "money-bill-alt";
    } else if (tempIcon === "cutlery") {
      tempIcon = "utensils";
    } else if (tempIcon === "shield") {
      tempIcon = "shield-alt";
    }
    setIcon(tempIcon as IconProp);
  }, []);

  return (
    <BenefitCardWrapper>
      <IconContainer color={primary_color}>
        <FontAwesomeIcon icon={icon} />
      </IconContainer>
      <BenefitCardHeader>
        {title}
      </BenefitCardHeader>
      <T300>
        {description}
      </T300>
    </BenefitCardWrapper>
  )
}

const BenefitsSection = ({
  hotelLoyalty,
  loyaltyBenefits,
}: BenefitsSectionProps) => {

  return (
    <BenefitsSectionWrapper>
      <BenefitsSectionContent>
        <TopContent>
          <T300 isStrong={true}>
            Your loyalty benefits
          </T300>
          <BenefitsSectionHeader>
            {hotelLoyalty.body_title}
          </BenefitsSectionHeader>
          <T300>
            {hotelLoyalty.body_subtitle}
          </T300>
        </TopContent>
        <BottomContent>
          {loyaltyBenefits.map((item, idx) => (
            <BenefitCard
              key={idx}
              icon_class={item.icon_class}
              title={item.title}
              description={item.description}
              primary_color={hotelLoyalty.primary_color}
            />
          ))}
        </BottomContent>
      </BenefitsSectionContent>

    </BenefitsSectionWrapper>
  )
}

export default BenefitsSection;
